import Vue from 'vue'

// 常量：个人中心抽屉的默认视图和默认定位模块
const DEFAULT_VIEW = 'overview'
const DEFAULT_SECTION = 'profile'

// 状态：全局抽屉只维护展示状态，业务数据仍由个人中心视图自身加载
const userCenterState = Vue.observable({
  visible: false,
  view: DEFAULT_VIEW,
  section: DEFAULT_SECTION,
  orderNo: ''
})

// 方法：打开个人中心概览，并按需定位到指定模块
export function openOverview(section = DEFAULT_SECTION) {
  userCenterState.view = DEFAULT_VIEW
  userCenterState.section = section || DEFAULT_SECTION
  userCenterState.orderNo = ''
  userCenterState.visible = true
}

// 方法：打开申请发票视图，并保留可选的订单预选参数
export function openInvoice(orderNo = '') {
  userCenterState.view = 'invoice'
  userCenterState.section = 'invoice'
  userCenterState.orderNo = orderNo || ''
  userCenterState.visible = true
}

// 方法：关闭全局个人中心抽屉并清除本次打开的临时参数
export function close() {
  userCenterState.visible = false
  userCenterState.view = DEFAULT_VIEW
  userCenterState.section = DEFAULT_SECTION
  userCenterState.orderNo = ''
}

export default {
  state: userCenterState,
  openOverview,
  openInvoice,
  close
}
